import { RefreshCw, Activity } from "lucide-react";

/**
 * Activity Log tab body, shared by the Normal, NetSuite and Business
 * Central request views. Purely presentational — the caller owns fetching
 * (see `utils/auditLog.js#formatAuditLogsForActivity`).
 */
export default function ActivityLogPanel({ logs, loading, onRefresh }) {
  return (
    <div className="flex-1 overflow-y-auto px-4 py-4 animate-panel-in">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
          Activity Log
        </h3>
        <button
          onClick={onRefresh}
          className="text-xs text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1"
        >
          <RefreshCw className={`w-3 h-3 ${loading ? "animate-spin" : ""}`} />
          Refresh
        </button>
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <RefreshCw className="w-4 h-4 animate-spin text-gray-400" />
          <span className="ml-2 text-xs text-gray-400">Loading activity...</span>
        </div>
      ) : logs.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <Activity className="h-6 w-6 text-gray-300 dark:text-gray-600 mb-1.5" />
          <p className="text-xs text-gray-400 dark:text-gray-500">No activity recorded yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {logs.map((log) => (
            <div key={log.id} className="flex items-start gap-2.5">
              <div
                className={`w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0 ${
                  log.icon === "user"
                    ? "bg-blue-500"
                    : log.icon === "bot"
                      ? "bg-purple-500"
                      : "bg-gray-400"
                }`}
              ></div>
              <div className="min-w-0 flex-1">
                <p className="text-xs text-gray-700 dark:text-gray-300 break-words">{log.action}</p>
                <p className="text-[10px] text-gray-400 dark:text-gray-500">{log.time}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
